"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var PaypalConfig = /*#__PURE__*/function () {
  function PaypalConfig(store, helpers) {
    var _this = this,
      _window$Configuration;
    _classCallCheck(this, PaypalConfig);
    _defineProperty(this, "onSubmit", function (state, component) {
      document.querySelector('#adyenStateData').value = JSON.stringify(state.data);
      _this.helpers.paymentFromComponent(state.data, component);
    });
    _defineProperty(this, "onCancel", function (data, component) {
      _this.store.paypalTerminatedEarly = false;
      _this.helpers.paymentFromComponent({
        cancelTransaction: true,
        merchantReference: document.querySelector('#merchantReference').value,
        orderToken: document.querySelector('#orderToken').value
      }, component);
    });
    _defineProperty(this, "onError", function (error, component) {
      _this.store.paypalTerminatedEarly = false;
      _this.helpers.paymentFromComponent({
        cancelTransaction: true,
        merchantReference: document.querySelector('#merchantReference').value,
        orderToken: document.querySelector('#orderToken').value
      }, component);
      if (component) {
        component.setStatus('ready');
      }
      document.querySelector('#showConfirmationForm').submit();
    });
    _defineProperty(this, "onAdditionalDetails", function (state) {
      _this.store.paypalTerminatedEarly = false;
      document.querySelector('#additionalDetailsHidden').value = JSON.stringify(state.data);
      document.querySelector('#showConfirmationForm').submit();
    });
    _defineProperty(this, "onClick", function (data, actions) {
      $('#dwfrm_billing').trigger('submit');
      if (_this.store.formErrorsExist) {
        return actions.reject();
      }
      if (_this.store.paypalTerminatedEarly) {
        _this.helpers.paymentFromComponent({
          cancelTransaction: true,
          merchantReference: document.querySelector('#merchantReference').value
        });
        _this.store.paypalTerminatedEarly = false;
        return actions.resolve();
      }
      _this.store.paypalTerminatedEarly = true;
      return null;
    });
    this.store = store;
    this.helpers = helpers;
    this.showPayButton = true;
    this.environment = ((_window$Configuration = window.Configuration) === null || _window$Configuration === void 0 ? void 0 : _window$Configuration.environment) || null;
    this.store.paypalTerminatedEarly = false;
  }
  return _createClass(PaypalConfig, [{
    key: "getConfig",
    value: function getConfig() {
      return {
        showPayButton: this.showPayButton,
        environment: this.environment,
        onSubmit: this.onSubmit,
        onCancel: this.onCancel,
        onError: this.onError,
        onAdditionalDetails: this.onAdditionalDetails,
        onClick: this.onClick
      };
    }
  }]);
}();
module.exports = PaypalConfig;